export function findFolderNode(nodes, key) {
  if (!key || !nodes?.length) return null
  for (const node of nodes) {
    if (String(node.id) === String(key)) return node
    const found = findFolderNode(node.children, key)
    if (found) return found
  }
  return null
}

/** 列表接口 folderId：根目录「全部素材」传 0，选中文件夹传 id，超管全局视图不传 */
export function resolveListFolderId(selectedNodeType, selectedFolderId, { globalAllView = false } = {}) {
  if (selectedNodeType === 'folder' && selectedFolderId) return selectedFolderId
  if (selectedNodeType === 'all' && !globalAllView) return 0
  return undefined
}

export function listChildFolderNodes(tree, selectedKey, selectedNodeType) {
  if (!tree?.length) return []

  if (!selectedKey || selectedKey === 'all' || selectedNodeType === 'all') {
    const root = tree.find((n) => n.nodeType === 'all') || tree[0]
    return (root?.children || []).filter((n) => n.nodeType === 'folder')
  }

  const current = findFolderNode(tree, selectedKey)
  if (!current) return []
  return (current.children || []).filter((n) => n.nodeType === 'folder')
}
